<app-navbar />
<main class="pt-20">
  <router-outlet />
</main>
<app-footer />
